import React, { useEffect } from 'react';
import Navbar from '../components/Navbar'; // Adjust path as per your project structure
import Footer from '../components/Footer'; // Adjust path as per your project structure

import headerImage from '../assets/images/rooms/header.jpg'; // Adjust path as per your project structure
import thumbnailKingIndoor from '../assets/images/rooms/thumbnail/king_indoor.jpg';
import thumbnailKingOutdoor from '../assets/images/rooms/thumbnail/king_outdoor.jpg';
import thumbnailFamily from '../assets/images/rooms/thumbnail/family.jpg';
import thumbnailBunks from '../assets/images/rooms/thumbnail/bunks.jpg';

import '../assets/css/secondary/style.css';
import '../assets/css/style.css';
import '../assets/css/style-core.css';
import '../assets/css/custom.css';
import '../assets/css/hotale-style-custom.css';
import '../assets/css/tourmaster-global-style-custom.css';
import '../assets/css/tourmaster-room-style-custom.css';
import '../assets/js/plugins/goodlayers-core/include/css/page-builder.css';
// import '../assets/js/plugins/tourmaster/room/tourmaster-room.css';

const Room = () => {
  useEffect(() => {
    // Initialize scripts
    if (window.jQuery) {
      // Ensure jQuery-dependent scripts are initialized
      if (window.jQuery.fn.flexslider) {
        window.jQuery('.gdlr-core-flexslider').flexslider({
          selector: '.slides > li',
          animation: 'slide',
          controlNav: false,
          directionNav: true,
          slideshow: false,
        });
      }
    }

    // Initialize WOW.js for animations if available
    if (window.WOW) {
      new window.WOW().init();
    }
  }, []);

  return (
    <div
      className="home page-template-default page page-id-14980 theme-hotale gdlr-core-body tourmaster-body woocommerce-no-js hotale-body hotale-body-front hotale-full hotale-with-sticky-navigation hotale-blockquote-style-3 gdlr-core-link-to-lightbox"
      data-home-url=""
    >
      {/* Internal CSS for styling the room cards */}
      <style>
        {`
           /* Import Yellowtail font from Google Fonts */
          @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');

          .hotale-page-title hotale-additional-font {
            font-family: 'Yellowtail', cursive !important;
            font-style: normal !important;
            font-weight: 400 !important;
            color: rgb(255, 255, 255) !important;
            font-size: 80px !important;
            line-height: 96px !important;
          }

          /* Mobile overrides for font styles */
          @media (max-width: 375px) {
            .hotale-page-title hotale-additional-font {
              font-size: 35px !important; /* Smaller font size for mobile */
              line-height: 56px !important; /* Smaller line height for mobile */
            }
          }

          /* Container for the room cards */
          .tourmaster-room-item-holder {
            display: flex;
            flex-wrap: nowrap; /* Keep cards in a single horizontal line */
            justify-content: center; /* Center the cards */
            gap: 10px; /* Reduced gap between cards to fit all four */
            padding: 0 20px; /* Padding on sides */
          }

          /* Individual room card */
          .tourmaster-room-grid {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 300px; /* Fixed width for each card */
  max-width: 300px; /* Ensure fixed width */
  margin-bottom: 0; /* No bottom margin since cards are in a single row */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex; /* Ensure flexbox for consistent height */
  flex-direction: column; /* Stack children vertically */
}

          .tourmaster-room-grid:hover {
            transform: translateY(-8px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
          }

          /* Inner container for flex layout */
          .tourmaster-room-grid-inner {
            display: flex;
            flex-direction: column;
            height: 100%;
          }

          /* Thumbnail image */
          .tourmaster-room-thumbnail img {
            width: 100%; /* Full width of the card */
            height: 200px; /* Fixed height for images */
            object-fit: cover; /* Maintain aspect ratio */
            border-bottom: 2px solid #eeb85e; /* Accent border */
          }

          /* Content area */
          .tourmaster-room-content-wrap {
  padding: 30px 20px !important; /* Increased padding */
  text-align: left; /* Align text to the left */
  background: #f9f9f9; /* Light background */
  min-height: 210px; /* Set a minimum height as fallback */
  flex-grow: 1; /* Allow content area to stretch to fill available space */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Distribute content vertically */
}

/* Synchronize height for content wrap using data-sync-height */
.tourmaster-room-content-wrap[data-sync-height="room-item-10"] {
  min-height: 240px; /* Increase min-height to match the tallest card */
}

          /* Room title */
          .tourmaster-room-title a {
            font-family: 'Poppins', sans-serif; /* Specified font family */
            font-size: 30px; /* Specified font size */
            font-weight: 500; /* Specified font weight */
            color: rgb(112, 112, 112); /* Specified color */
            line-height: 36px; /* Specified line height */
            text-decoration: none;
            display: block;
            margin-bottom: 12px; /* Space below title */
            transition: color 0.3s ease;
          }

          .tourmaster-room-title a:hover {
            color: #eeb85e; /* Accent color on hover */
          }

          /* Info section (bed type, guest amount) */
          .tourmaster-info-wrap {
            display: flex;
            justify-content: flex-start; /* Align info items to the left */
            gap: 15px; /* Space between info items */
            margin-bottom: 15px; /* Space below info */
            font-size: 14px; /* Smaller font for secondary text */
            font-weight: 400; /* Regular weight */
            color: #666; /* Softer color for secondary text */
          }

          .tourmaster-info i {
            margin-right: 5px; /* Space between icon and text */
            color: #eeb85e; /* Accent color for icons */
            font-size: 16px; /* Slightly larger icons */
          }

          .tourmaster-info span {
            line-height: 1.5; /* Better line spacing */
          }

          /* Book Now button */
          .tourmaster-read-more {
            display: inline-flex;
            align-items: center;
            gap: 5px;
            font-family: 'Poppins', sans-serif; /* Match font family */
            font-size: 14px;
            font-weight: 500; /* Medium weight */
            color: #666; /* Match secondary text color */
            text-transform: uppercase;
            text-decoration: none;
            transition: font-size 0.2s ease, color 0.3s ease; /* Transition for hover effects */
          }

          .tourmaster-read-more:hover {
            font-size: 15px; /* Slightly increase font size on hover */
            color: rgb(112, 112, 112); /* Match title color on hover */
          }

          .tourmaster-read-more i {
            font-size: 12px; /* Smaller icon */
          }

          /* Responsive adjustments */
          @media (max-width: 1200px) {
            .tourmaster-room-item-holder {
              flex-wrap: wrap; /* Allow wrapping on smaller screens */
              justify-content: center;
            }

            .tourmaster-room-grid {
              margin-bottom: 20px; /* Add margin for spacing when wrapped */
            }
          }

          @media (max-width: 992px) {
            .tourmaster-room-grid {
              width: 45%; /* Two cards per row */
              max-width: 45%;
            }

            .tourmaster-room-thumbnail img {
              height: 180px; /* Slightly smaller images */
            }

            .tourmaster-room-content-wrap {
              min-height: 200px; /* Adjust min-height for smaller screens */
            }
          }

          @media (max-width: 768px) {
            .tourmaster-room-grid {
              width: 100%; /* One card per row */
              max-width: 350px;
            }

            .tourmaster-room-item-holder {
              gap: 15px;
            }

            .tourmaster-room-thumbnail img {
              height: 200px;
            }

            .tourmaster-room-content-wrap {
              min-height: 190px; /* Adjust min-height for smaller screens */
            }
          }

          @media (max-width: 480px) {
            .tourmaster-room-grid {
              max-width: 100%;
            }

            .tourmaster-room-title a {
              font-size: 24px; /* Smaller font for mobile */
              line-height: 30px; /* Adjust line height proportionally */
            }

            .tourmaster-info-wrap {
              font-size: 13px;
              gap: 10px;
            }

            .tourmaster-read-more {
              font-size: 13px;
            }

            .tourmaster-read-more:hover {
              font-size: 14px; /* Adjusted hover size for mobile */
            }

            .tourmaster-room-content-wrap {
              min-height: 180px; /* Adjust min-height for smaller screens */
            }
          }
        `}
      </style>

      <Navbar />
      {/* Sidebar components */}
      <div className="sidebar-oryza">
        {/* Assuming sidebaroryza content is static or managed elsewhere */}
      </div>
      <div className="sidebar">
        {/* Assuming sidebar content is static or managed elsewhere */}
      </div>

      <div
        className="hotale-page-title-wrap hotale-style-custom hotale-center-align"
        style={{ backgroundImage: `url(${headerImage})` }}
      >
        <div className="hotale-header-transparent-substitute"></div>
        <div className="hotale-page-title-overlay"></div>
        <div className="hotale-page-title-container hotale-container">
          <div className="hotale-page-title-content hotale-item-pdlr">
            <h1 className="hotale-page-title hotale-additional-font">
              <b>Our Rooms and Bunks</b>
            </h1>
          </div>
        </div>
      </div>

      <div className="hotale-page-wrapper bbmirissabg" id="hotale-page-wrapper">
        <div className="gdlr-core-page-builder-body">
          <div className="gdlr-core-pbf-wrapper" style={{ padding: '80px 0px 15px 0px' }}>
            <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
              <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                <div className="gdlr-core-pbf-element">
                  <div className="tourmaster-room-item clearfix tourmaster-room-item-style-grid">
                    <div
                      className="tourmaster-room-item-holder gdlr-core-js-2 clearfix"
                      data-layout="fitrows"
                    >
                      {/* Room 1: Deluxe King Room with Indoor Spa Bath */}
                      <div className="gdlr-core-item-list tourmaster-item-pdlr">
                        <div className="tourmaster-room-grid tourmaster-grid-frame">
                          <div className="tourmaster-room-grid-inner">
                            <div className="tourmaster-room-thumbnail tourmaster-media-image gdlr-core-outer-frame-element tourmaster-with-price">
                              <a href="/bbmirissa/room/kingroomwithindoorbath">
                                <img
                                  src={thumbnailKingIndoor}
                                  alt="Deluxe King Room with Indoor Spa Bath"
                                  width="700"
                                  height="450"
                                />
                              </a>
                            </div>
                            <div
                              className="tourmaster-room-content-wrap gdlr-core-skin-e-background gdlr-core-js"
                              data-sync-height="room-item-10"
                            >
                              <h3 className="tourmaster-room-title gdlr-core-skin-title">
                                <a href="/bbmirissa/room/kingroomwithindoorbath">
                                  Deluxe King Room<br />with Indoor Spa Bath
                                </a>
                              </h3>
                              <div className="tourmaster-info-wrap clearfix">
                                <div className="tourmaster-info tourmaster-info-bed-type">
                                  <i className="gdlr-icon-double-bed2"></i>
                                  <span className="tourmaster-tail">1 King Bed</span>
                                </div>
                                <div className="tourmaster-info tourmaster-info-guest-amount">
                                  <i className="gdlr-icon-group"></i>
                                  <span className="tourmaster-tail">2 Guests</span>
                                </div>
                              </div>
                              <a
                                className="tourmaster-read-more tourmaster-type-text"
                                href="/bbmirissa/room/kingroomwithindoorbath"
                              >
                                Book Now<i className="icon-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Room 2: Deluxe King Room with Outdoor Spa Bath */}
                      <div className="gdlr-core-item-list tourmaster-item-pdlr">
                        <div className="tourmaster-room-grid tourmaster-grid-frame">
                          <div className="tourmaster-room-grid-inner">
                            <div className="tourmaster-room-thumbnail tourmaster-media-image gdlr-core-outer-frame-element tourmaster-with-price">
                              <a href="/bbmirissa/room/kingroomwithoutdoorbath">
                                <img
                                  src={thumbnailKingOutdoor}
                                  alt="Deluxe King Room with Outdoor Spa Bath"
                                  width="700"
                                  height="450"
                                />
                              </a>
                            </div>
                            <div
                              className="tourmaster-room-content-wrap gdlr-core-skin-e-background gdlr-core-js"
                              data-sync-height="room-item-10"
                            >
                              <h3 className="tourmaster-room-title gdlr-core-skin-title">
                                <a href="/bbmirissa/room/kingroomwithoutdoorbath">
                                  Deluxe King Room with Outdoor Spa Bath
                                </a>
                              </h3>
                              <div className="tourmaster-info-wrap clearfix">
                                <div className="tourmaster-info tourmaster-info-bed-type">
                                  <i className="gdlr-icon-double-bed2"></i>
                                  <span className="tourmaster-tail">1 Large & Single</span>
                                </div>
                                <div className="tourmaster-info tourmaster-info-guest-amount">
                                  <i className="gdlr-icon-group"></i>
                                  <span className="tourmaster-tail">3 Guests</span>
                                </div>
                              </div>
                              <a
                                className="tourmaster-read-more tourmaster-type-text"
                                href="/bbmirissa/room/kingroomwithoutdoorbath"
                              >
                                Book Now<i className="icon-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Room 3: Deluxe Family Room With 3 Beds */}
                      <div className="gdlr-core-item-list tourmaster-item-pdlr">
                        <div className="tourmaster-room-grid tourmaster-grid-frame">
                          <div className="tourmaster-room-grid-inner">
                            <div className="tourmaster-room-thumbnail tourmaster-media-image gdlr-core-outer-frame-element tourmaster-with-price">
                              <a href="/bbmirissa/room/familyroom">
                                <img
                                  src={thumbnailFamily}
                                  alt="Deluxe Family Room With 3 Beds"
                                  width="700"
                                  height="450"
                                />
                              </a>
                            </div>
                            <div
                              className="tourmaster-room-content-wrap gdlr-core-skin-e-background gdlr-core-js"
                              data-sync-height="room-item-10"
                            >
                              <h3 className="tourmaster-room-title gdlr-core-skin-title">
                                <a href="/bbmirissa/room/familyroom">
                                  Deluxe Family Room With 3 Beds
                                </a>
                              </h3>
                              <div className="tourmaster-info-wrap clearfix">
                                <div className="tourmaster-info tourmaster-info-bed-type">
                                  <i className="gdlr-icon-double-bed2"></i>
                                  <span className="tourmaster-tail">3 Double Beds</span>
                                </div>
                                <div className="tourmaster-info tourmaster-info-guest-amount">
                                  <i className="gdlr-icon-group"></i>
                                  <span className="tourmaster-tail">6 Guests</span>
                                </div>
                              </div>
                              <a
                                className="tourmaster-read-more tourmaster-type-text"
                                href="/bbmirissa/room/familyroom"
                              >
                                Book Now<i className="icon-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Room 4: Bed in 6-Bed Mixed Dormitory Room */}
                      <div className="gdlr-core-item-list tourmaster-item-pdlr">
                        <div className="tourmaster-room-grid tourmaster-grid-frame">
                          <div className="tourmaster-room-grid-inner">
                            <div className="tourmaster-room-thumbnail tourmaster-media-image gdlr-core-outer-frame-element tourmaster-with-price">
                              <a href="/bbmirissa/room/dormitoryroom">
                                <img
                                  src={thumbnailBunks}
                                  alt="Bed in 6-Bed Mixed Dormitory Room"
                                  width="700"
                                  height="450"
                                />
                              </a>
                            </div>
                            <div
                              className="tourmaster-room-content-wrap gdlr-core-skin-e-background gdlr-core-js"
                              data-sync-height="room-item-10"
                            >
                              <h3 className="tourmaster-room-title gdlr-core-skin-title">
                                <a href="/bbmirissa/room/dormitoryroom">
                                  Bed in 6-Bed Mixed Dormitory Room
                                </a>
                              </h3>
                              <div className="tourmaster-info-wrap clearfix">
                                <div className="tourmaster-info tourmaster-info-bed-type">
                                  <i className="gdlr-icon-double-bed2"></i>
                                  <span className="tourmaster-tail">6 Bunk Beds</span>
                                </div>
                                <div className="tourmaster-info tourmaster-info-guest-amount">
                                  <i className="gdlr-icon-group"></i>
                                  <span className="tourmaster-tail">6 Guests</span>
                                </div>
                              </div>
                              <a
                                className="tourmaster-read-more tourmaster-type-text"
                                href="/bbmirissa/room/dormitoryroom"
                              >
                                Book Now<i className="icon-arrow-right"></i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Room;